function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import isEmpty from 'lodash/fp/isEmpty';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import WhiteContainer from '../../../components/containers/WhiteContainer';
import List from '../../../components/list/List';
import Loading from '../../../components/loading/Loading';
import { MapViewContext } from '../../../components/mapView/mapViewContext';
import { getJob } from '../../../redux/actions';
import text, { formatCurrency } from '../../../text';
import { isMembershipPriceId } from '../../../utilities/membership';
import { userHasActiveMembership } from '../../../utilities/user';
import ChargeItem from './ChargeItem';
import { PaymentContext } from '../PaymentContext';
var ProductInvoice = function(param) {
    var jobId = param.jobId, numOrder = param.numOrder;
    var dispatch = useDispatch();
    var _useContext = useContext(MapViewContext), buyNowData = _useContext.state.buyNowData;
    var _useSelector = useSelector(function(state) {
        return {
            job: state.jobsReducer.job,
            membershipPriceId: state.order.membershipPriceId,
            currentUser: state.profileReducer.userProfile,
            isGettingJob: state.jobsReducer.isGettingJob,
            isQuotingJob: state.jobsReducer.isQuotingJob
        };
    }), job = _useSelector.job, membershipPriceId = _useSelector.membershipPriceId, currentUser = _useSelector.currentUser, isGettingJob = _useSelector.isGettingJob, isQuotingJob = _useSelector.isQuotingJob;
    var _useContext1 = useContext(PaymentContext), cardHeading = _useContext1.states.cardHeading;
    useEffect(function() {
        _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                if (jobId && !isGettingJob && isEmpty(job)) {
                    dispatch(getJob(jobId));
                }
                return [
                    2
                ];
            });
        })();
    }, [
        dispatch,
        isGettingJob,
        job,
        jobId
    ]);
    if (!job) {
        return null;
    }
    var quote = job.quote;
    if (buyNowData.length <= 0) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(WhiteContainer, {
        className: "Invoice position-relative"
    }, isQuotingJob ? /*#__PURE__*/ React.createElement("div", {
        className: "position-absolute overlay-loader-container"
    }, /*#__PURE__*/ React.createElement(Loading, null)) : null, !quote ? null : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h6", {
        className: "green-1 font-weight--600 mb-0"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "mr-1"
    }, numOrder, "."), ' ', /*#__PURE__*/ React.createElement("span", null, text('_invoiceType', {
        prefix: cardHeading,
        type: text('Data in the Database')
    }))), /*#__PURE__*/ React.createElement("div", {
        style: {
            paddingLeft: '20px',
            paddingRight: '16px'
        }
    }, /*#__PURE__*/ React.createElement(List, null, buyNowData.map(function(param, i) {
        var discounts = param.discounts, details = param.details, price = param.price, fees = param.fees, member_discounts_preview = param.member_discounts_preview;
        return /*#__PURE__*/ React.createElement(ChargeItem, {
            key: i,
            displayName: text("".concat(details.category_name, "3D")),
            discounts: isMembershipPriceId(membershipPriceId) ? member_discounts_preview : discounts,
            details: details,
            price: price,
            fees: fees,
            quote: quote,
            isIndividualDiscountVisible: !userHasActiveMembership(currentUser) && !isMembershipPriceId(membershipPriceId)
        });
    }), !isEmpty(quote.discounts) && quote.discounts.map(function(discount, i) {
        var _discount_price;
        return /*#__PURE__*/ React.createElement(List.Item, {
            className: "discount font-pink pl-3 pt-1 font-italic",
            key: i,
            description: discount.display_name,
            value: "—".concat(formatCurrency((_discount_price = discount.price) === null || _discount_price === void 0 ? void 0 : _discount_price.subtotal, quote.currency.name, quote.currency.scale_factor, {}, true))
        });
    })))));
};
ProductInvoice.propTypes = {
    jobId: PropTypes.number,
    numOrder: PropTypes.number
};
export default ProductInvoice;
